import { NgModule } from '@angular/core';
import { SimpleChartComponent } from './components/simple-chart/simple-chart.component';
import { StatisticChartComponent } from './components/statistic-chart/statistic-chart.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ImgValidatorPipe } from './pipes/img-validator.pipe';
import { CasesColorPipe } from './pipes/cases-color.pipe';
import { SafePipe } from './pipes/safe-url-pipe';

const exportsComponents = [
  SimpleChartComponent,
  StatisticChartComponent
];
const exportsPipes = [
  ImgValidatorPipe,
  CasesColorPipe,
  SafePipe
];

@NgModule({
  imports: [
    MatProgressSpinnerModule
  ],
  declarations: [
    ...exportsComponents,
    ...exportsPipes
  ],
  exports: [...exportsComponents, ...exportsPipes],
  providers: [...exportsPipes]

})
export class SharedModule {}
